var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"pointer",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"}},'div',attrs,false),on),[_vm._v("   ")])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }